import { Step } from "../types";

export const getSections = <PathType>(steps: Step<PathType>[]) =>
  steps.reduce(
    (acc, step) => {
      if (!step.section) return acc;
      const path = `/${step.path}`;
      if (step.section in acc) {
        acc[step.section].push(path);
      } else {
        acc[step.section] = [path];
      }
      return acc;
    },
    {} as Record<string, string[]>
  );
